const roleAbstractEntities = ['PolicyContactRole',
    'BAPolicyContactRole',
    'BOPPolicyContactRole',
    'CPPolicyContactRole',
    'GLPolicyContactRole',
    'PAPolicyContactRole',
    'IMPolicyContactRole',
    'PolicyNamedInsured',
    'WCPolicyContactRole',
    'WCLaborContact',
    'PlcyNonPriNamedInsured',
    'PolicyNamedInsured'];

class PolicyContactsSummaryTable {

    constructor(InsuranceSuiteMetadata, $filter, ContactService) {
        this._InsuranceSuiteMetadata = InsuranceSuiteMetadata;
        this._translateRole = name => $filter('translate')(`gateway.contacts.common.views.policy.roles.${name}`);
        this._contactsService = ContactService;
    }

    $onInit() {
        this.roleOptions = this._InsuranceSuiteMetadata.get('pc').types.getTypelist('PolicyContactRole').codes
            .filter(c => !roleAbstractEntities.includes(c.code)) // Removes abstract entities for Policy Roles
            .map(c => {
                return {name: this._translateRole(c.name), code: c.code};
            });

        this.selectedContactRole = null;
        this.resetQuery()
            .then(() => this.onInitialLoad({totalContactCount: this.totalContacts}));
    }

    resetQuery() {
        return this.loadContacts(0, this.pageSize);
    }

    loadContacts(toPage, pageSize) {
        const currentPage = toPage;
        const roleFilter = this.selectedContactRole ? [this.selectedContactRole] : [];
        this.loaded = false;

        return this._contactsService.getPolicyContactSummaries(this.policyNumber, roleFilter, currentPage, pageSize)
            .then((data) => {
                this.contacts = data.policyContacts;
                this.firstContact = currentPage * pageSize;
                this.currentPage = currentPage;
                this.totalContacts = data.maxNumberOfResults;
                this.loaded = true;
            });

    }

}

PolicyContactsSummaryTable.$inject = ['InsuranceSuiteMetadata', '$filter', 'ContactService'];

export default PolicyContactsSummaryTable;